import { IBankAccount, IPaymentAccounts, ICard, IBankVerification } from '../../model/models/payment-methods';
import { IBankAccountEntity, IPaymentAccountsEntity, ICardEntity, IValidateCardEntity, IValidateCardResponseEntity, IBankVerificationEntity } from '../../model/api/payment-accounts';
import { AddressType } from '../../model/types/address-type';


export class PaymentMapper {
  public static fromBankPaymentEntity(entity: IBankAccountEntity): IBankAccount {
    return {
      type: entity.accountType,
      name: entity.bankName,
      routingCode: entity.localRoutingCode,
      routingCodeType: entity.routingCodeType,
      verificationStatus: entity.verificationStatus,
      accountId: entity.accountId,
      paymentMethod: entity.paymentMethod,
      accountNumber: entity.accountNumber,
      maskedAccountNumber: entity.maskedAccountNumber ? `...${entity.maskedAccountNumber.substring(entity.maskedAccountNumber.length - 4)}` : null,
      accountAlias: entity.accountAlias,
      country: entity.accountCountry,
      currency: entity.accountCurrency,
      itemLoginRequired: entity.itemLoginRequired,
      isDisabled: entity.disabled,
      isDuplicate: entity.duplicate,
      dateCreated: entity.createdDate,
      accountHolderFirstName: entity.firstName,
      accountHolderMiddleName: entity.middleName,
      accountHolderLastName: entity.lastName,
      bankVerificationPublicToken:entity.bankVerificationPublicToken,
      address: {
        type: AddressType.Billing.toString(),
        street: entity.billingAddress,
        city: entity.billingCity,
        stateProvince: entity.billingState,
        country: entity.billingCountry,
        postCode: entity.billingPostalCode
      },
      bankAccountVerificationType: entity.bankAccountVerificationType,
      bankAccountMicroDepositStatus: entity.bankAccountMicroDepositStatus,
      padConsentRequired: entity.padConsentRequired,
      plaidLinkEligible: entity.plaidLinkEligible === true
    };
  }

  public static fromPaymentAccountsEntity(entities: IPaymentAccountsEntity): IPaymentAccounts {
    return {
      bankAccounts: entities.bankAccounts.map(account => this.fromBankPaymentEntity(account)),
      cards: entities.cardAccounts.map(card => this.fromCardPaymentEntity(card)),
      pspSession: entities.pspSession,
      allowedCardBrands: entities.allowedCardBrands
    }
  }

  public static fromCardPaymentEntity(entity: ICardEntity): ICard {
    return {
      accountId: entity.accountId,
      type: entity.accountType,
      alias: entity.accountAlias,
      expiryMonth: entity.accountExpirationMonth,
      expiryYear: entity.accountExpirationYear,
      maskedAccountNumber: entity.maskedAccountNumber ? `...${entity.maskedAccountNumber.substring(entity.maskedAccountNumber.length - 4)}` : null,
      isDisabled: entity.disabled,
      firstName: entity.firstName,
      lastName: entity.lastName,
      isExpired: entity.isExpired,
      // firstNameCard: entity.firstNameCard,
      // lastNameCard: entity.lastNameCard,
      // firstNameBilling: entity.firstNameBilling,
      // lastNameBilling: entity.lastNameBilling,
      country: entity.billingCountry,
      street: entity.billingAddress,
      city: entity.billingCity,
      stateProvince: entity.billingState,
      postCode: entity.billingPostalCode,
      isDebit: entity.isDebit,
      isCvnRequired: entity.isCvnRequired,
      paymentProcessor: entity.paymentProcessor,
    };
  }

  public static toCardEntity(card: ICard): ICardEntity {
    return {
      accountId: card.accountId,
      accountType: card.type,
      accountAlias: card.alias,
      accountExpirationMonth: card.expiryMonth,
      accountExpirationYear: card.expiryYear,
      maskedAccountNumber: card.maskedAccountNumber,
      disabled: card.isDisabled,
      firstName: card.firstName,
      lastName: card.lastName,
      isExpired: card.isExpired,
      // firstNameCard: card.firstNameCard,
      // lastNameCard: card.lastNameCard,
      // firstNameBilling: card.firstNameBilling,
      // lastNameBilling: card.lastNameBilling,
      billingAddress: card.street,
      billingCity: card.city,
      billingState: card.stateProvince,
      billingPostalCode: card.postCode,
      isDebit: card.isDebit,
      isCvnRequired: card.isCvnRequired,
      paymentProcessor: card.paymentProcessor
    };
  }
public static fromPlaidAccountEntitiy(model):IBankAccountEntity{
  /*institution:{name:'Chase',institution_id:'ins_3',}
  account:{name:'Plaid Saving',id:'5A8EkkVE8ZtJJMRaMgraHKbykldWmoSZn647V',type:'depository',subtype:'savings',mask:'1111'}*/
  /*accountId: this.accountID,
  accountType:accountType,
  firstName:customer.firstName,
  middleName:customer.middleName,
  lastName:customer.lastName,
  billingAddress:customer.address.street,
  billingCity:customer.address.city,
  billingPostalCode:customer.address.postCode,
  billingState:customer.address.stateProvince,
  maskedAccountNumber: accountmask,
  bankName:bankName,
  publicToken:this.publicToken*/
  let  account:IBankAccountEntity = {
        accountType:model.accountType,
        instantBankVerification:{
          accountId: model.accountId,
          publicToken:model.publicToken,
          metaData:model.metaData
        },
        firstName:model.firstName,
        middleName:model.middleName,
        lastName:model.lastName,
        billingAddress:model.billingAddress,
        billingCity:model.billingCity,
        billingPostalCode:model.billingPostalCode,
        billingState:model.billingState,
        maskedAccountNumber: model.maskedAccountNumber,
        bankName:model.bankName
      };
    if (model.replacesPaymentAccountId !== undefined && model.replacesPaymentAccountId !== null)
      account.replacesPaymentAccountId = model.replacesPaymentAccountId;
    return account;
  // return  {
  //   accountType:model.accountType,
  //   localRoutingCode:model.routing,
  //   accountNumber:model.accountNumber,
  //   instantBankValidationInfo:{
  //     accessToken: model.accessToken,
  //     itemId:model.itemId,
  //     accountId: model.accountId,
  //   },

  // };
}
  public static formToBankAccountEntity(model: any): IBankAccountEntity {
    return {
      bankName: model.name,
      localRoutingCode: model.localRoutingCode,
      routingCodeType: model.routingCodeType,
      verificationStatus: model.verificationStatus,
      accountId: model.accountId,
      paymentMethod: model.paymentMethod,
      disabled: model.isDisabled,
      accountNumber: model.accountNumber,
      maskedAccountNumber: model.maskedAccountNumber,
      accountAlias: model.accountAlias,
      firstName: model.firstName,
      lastName: model.lastName,
      middleName: model.middleName,
      accountCountry: model.country,
      accountCurrency: model.currency,
      billingAddress: model.billingAddress,
      billingCity: model.billingCity,
      billingState: model.billingState,
      billingCountry: model.country,
      billingPostalCode: model.billingPostalCode,
      duplicate: model.isDuplicate,
      createdDate: new Date().toString(),
      accountType: model.accountType
    };
  }

  public static formToCard(model: any): ICard {
    return {
      type: model.cardType,
      expiryMonth: model.accountExpirationMonth,
      expiryYear: model.accountExpirationYear,
      maskedAccountNumber: model.maskedAccountNumber,
      alias: model.accountAlias,
      isDisabled: false,
      accountNumber: model.cardNumber,
      firstName: model.firstName,
      lastName: model.lastName,
      // firstNameCard: model.firstNameCard,
      // lastNameCard: model.lastNameCard,
      // firstNameBilling: model.firstNameBilling,
      // lastNameBilling: model.lastNameCard,
      country: model.billingCountry,
      street: model.billingAddress,
      city: model.billingCity,
      stateProvince: model.billingState,
      postCode: model.billingPostalCode,
      cvn: model.cVV,
      isDebit: model.isDebit,
      isCvnRequired: model.isCvnRequired
    };
  }

  public static toValidateCardEntity(model: ICard, signatureFields): IValidateCardEntity {
    return {
      AccountNumberFirstSix: model.accountNumber.substr(0,6),
      AccountNumberLastFour: model.accountNumber.substr(model.accountNumber.length - 4, 4),
      AccountExpirationMonth: model.expiryMonth,
      AccountExpirationYear: model.expiryYear,
      BillingPostalCode: model.postCode,
      SignatureFields: signatureFields
    }
  }

  public static toBankVerificationEntity(model: IBankVerification): IBankVerificationEntity {
    return {
      accountId: model.accountId,
      verificationDeposit1: model.verificationDeposit1 / 100,
      verificationDeposit2: model.verificationDeposit2 / 100
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/payment/payment.mapper.ts